module.exports = __webpack_public_path__ + "static/media/CIOB1.dde9d9b7.png";